import { Injectable } from '@angular/core';
import { BaseReactiveStore } from "../../shared/base-reactive-store";
import { ApplicationConfigurationDto, LocalizationDto } from "./models/application-configuration-dto";
import { HttpClient } from "@angular/common/http";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { Observable } from "rxjs";
import { EnvironmentService } from '../environment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService extends BaseReactiveStore<ApplicationConfigurationDto> {

  grantedPolicies$: Observable<Record<string, boolean>>
    = this.select(state => state.auth.grantedPolicies)

  localization$: Observable<LocalizationDto>
    = this.select(state => state.localization)

  constructor(private http: HttpClient, private oidc: OidcSecurityService, private environmentService: EnvironmentService) {
    super(new ApplicationConfigurationDto())

    this.refreshConfiguration()
    this.oidc.isAuthenticated$.subscribe(() => this.refreshConfiguration())
  }

  refreshConfiguration() {
    this.http.get<ApplicationConfigurationDto>(this.environmentService.getConfig().api.baseUrl + '/api/abp/application-configuration')
      .subscribe((val) => this.setState(val))
  }
}
